import Vue from "vue/dist/vue.min.js";
import "@babel/polyfill";
import inlineTitleUrl from "./sub-components/inlineTitleUrl";

const params = new URL(document.location).searchParams;
let state = params.get("filter");

new Vue({
  el: "#fundingOpportunities",
  delimiters: ["${", "}"],
  components: {
    inlineTitleUrl: inlineTitleUrl,
  },
  data: {
    region: state !== null ? state : "",
  },
});
